import React from 'react';

import { formatUser } from '../../helpers/user';
import { useUserData } from '../../contexts/UserDataContext';

export const withUser = (Component) => (props) => {
  const { user, logout } = useUserData();
  const formattedUser = formatUser(user);

  return <Component user={formattedUser} logout={logout} {...props} />;
};
